import React from 'react';

import { ErrorState } from '@xingternal/pages-common';

type WarningMessageBoxProps = {
  headerText?: string;
  bodyText: string;
  buttonText?: string;
  onClick?: () => void;
  to?: () => void;
  href?: string;
};

const WarningMessageBox = ({
  headerText,
  bodyText,
  buttonText,
  onClick,
  to,
  href,
} : WarningMessageBoxProps) => (
  <ErrorState
    headlineCopyKey={headerText}
    textCopyKey={bodyText}
    customButton
    buttonProps={{
      copyKey: buttonText,
      onClick,
      to,
      href,
    }}
  />
);

export default WarningMessageBox;
